module.exports = __webpack_public_path__ + "static/media/default_task_image.a674a487.png";